module.exports = __webpack_public_path__ + "static/media/Problems-to-Watch-Adults-r-l.bd36b55b.pdf";